import { Box, Button, Flex } from '@gmg/gmg-react-components';
import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import UploadLocalFile, { UploadedFile } from './UploadLocalFile';
export interface AddNewLicenseSystemToOrgModalProps {
    onClose?: () => void;
    onSubmit: (fileContent: string) => void;
};

const AddNewLicenseSystemToOrgModal: FunctionComponent<AddNewLicenseSystemToOrgModalProps> = (props) => {
    const { t } = useTranslation();
    const [deviceFileFromDisk, setDeviceFileFromDisk] = useState<undefined | UploadedFile>(undefined);

    return (
        <Flex mr="24px" ml="24px" flexDirection="column" gap='40px'>

            <Box className="px12_400_normal">
                {t('AddNewLicenseSystemToOrg.modal_desc', 'You can manually add a license system here without the application service. This can be done in offline, and does not require an internet connection of the license system itself.')}
            </Box>

            <UploadLocalFile
                id={'deviceFile'}
                label={t('AddNewLicenseSystemToOrg.input_deviceFile_label', 'Upload device file')}
                acceptedFileFormat='.lic'
                buttonProps={{ title: t('AddNewLicenseSystemToOrg.select_btn', 'Select file'), variant: 'primary' }}
                onFinishUpload={setDeviceFileFromDisk}
            />

            <Flex justifyContent="flex-end" gap="10px">
                <Button
                    variant="primary"
                    type="submit"
                    disabled={!deviceFileFromDisk}
                    onClick={() => {
                        props.onSubmit(deviceFileFromDisk!.content);
                        props.onClose?.();
                    }}
                >
                    {t('ButtonTitles.action_add_system_btn', 'Add system')}
                </Button>
                <Button
                    variant="secondary"
                    type="reset"
                    onClick={() => props.onClose?.()}
                >
                    {t('ButtonTitles.action_cancel_btn', 'Cancel')}
                </Button>
            </Flex>
        </Flex>
    );
};

export default AddNewLicenseSystemToOrgModal;